import React from "react";

const TeamSetupCheckbox = ({ onChange, checked, enabled = true }) => (
  <div className={`team-setup--checkbox enabled-${enabled}`}>
    <label>
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="cr">
        <i className="cr-icon fa fa-check" />
      </span>
    </label>
  </div>
);
export default TeamSetupCheckbox;
